<template>
  <v-container
    fluid
    tag="section"
  >
    <base-material-card
      icon="mdi-cog-outline"
      title="ClinicOne — Administração global"
      color="secondary"
    >
      <v-tabs
        v-model="activeTab"
        background-color="transparent"
        color="secondary"
        show-arrows
        class="mb-3"
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab.key"
        >
          <v-icon
            small
            class="mr-1"
          >
            {{ tab.icon }}
          </v-icon>
          {{ tab.label }}
        </v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="activeTab"
        class="transparent"
      >
        <v-tab-item
          v-for="tab in tabs"
          :key="tab.key"
        >
          <component
            :is="tab.component"
            v-if="loadedTabs[tab.key]"
          />
        </v-tab-item>
      </v-tabs-items>
    </base-material-card>
  </v-container>
</template>

<script>
  import PlansSection from './components/clinicOneGlobal/PlansSection.vue'
  import CouponsSection from './components/clinicOneGlobal/CouponsSection.vue'
  import SubscriptionsSection from './components/clinicOneGlobal/SubscriptionsSection.vue'
  import GlobalDictionariesSection from './components/clinicOneGlobal/GlobalDictionariesSection.vue'
  import PermissionsCatalogSection from './components/clinicOneGlobal/PermissionsCatalogSection.vue'

  const TABS = [
    { key: 'plans', label: 'Planos', icon: 'mdi-package-variant-closed', component: 'PlansSection' },
    { key: 'coupons', label: 'Cupons', icon: 'mdi-ticket-percent-outline', component: 'CouponsSection' },
    { key: 'subscriptions', label: 'Assinaturas', icon: 'mdi-card-account-details-outline', component: 'SubscriptionsSection' },
    { key: 'dictionaries', label: 'Dicionários globais', icon: 'mdi-book-alphabet', component: 'GlobalDictionariesSection' },
    { key: 'permissions', label: 'Catálogo de permissões', icon: 'mdi-shield-key-outline', component: 'PermissionsCatalogSection' },
  ]

  export default {
    name: 'DashboardClinicOne',

    components: {
      PlansSection,
      CouponsSection,
      SubscriptionsSection,
      GlobalDictionariesSection,
      PermissionsCatalogSection,
    },

    data: () => ({
      activeTab: 0,
      tabs: TABS,
      loadedTabs: { plans: true },
    }),

    watch: {
      activeTab (idx) {
        const key = this.tabs[idx]?.key
        if (key) this.$set(this.loadedTabs, key, true)
      },
    },
  }
</script>
